// Wraps a route element so only admins can reach it. Non-admins are
// redirected home. Used to lock /library and friends: the Library is an
// internal record of everything every user does so we can build more
// efficiently — regular users access the same content via the main prompt.
import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";

export default function AdminOnlyRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, loading } = useUserRole();
  if (loading) return null;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}